/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

const randomCommandKey = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `lead-stage-${Date.now()}`;
};

const commandKey = (payload = {}) =>
  payload.idempotency_key || payload.idempotencyKey || randomCommandKey();

const commandConfig = payload => {
  const config = requestConfig();
  config.headers['Idempotency-Key'] = commandKey(payload);
  return config;
};

class LeadStageTransitionsAPI extends ApiClient {
  constructor() {
    super('lead_stage_transitions', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  show(id) {
    return axios.get(resourcePath(this.url, id), requestConfig());
  }

  create(payload = {}) {
    return axios.post(
      this.url,
      { lead_stage_transition: payload },
      commandConfig(payload)
    );
  }
}

export default new LeadStageTransitionsAPI();
